const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Auth functions
export const login = async (username, password) => {
  const response = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Login failed');
  }
  
  const data = await response.json();
  localStorage.setItem('token', data.access_token);
  return data;
};

export const register = async (username, password) => {
  const response = await fetch(`${API_URL}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Registration failed');
  }
  
  const data = await response.json();
  localStorage.setItem('token', data.access_token);
  return data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_URL}/api/auth/change-password?current_password=${encodeURIComponent(currentPassword)}&new_password=${encodeURIComponent(newPassword)}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Password change failed');
  }
  
  return await response.json();
};

export const verifyToken = async () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  
  try {
    const response = await fetch(`${API_URL}/api/auth/verify`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.ok;
  } catch {
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
};

// Helper function for authenticated requests
const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  };
  
  const response = await fetch(`${API_URL}${url}`, config);
  
  if (response.status === 401) {
    logout();
    window.location.href = '/admin/login';
    throw new Error('Unauthorized');
  }
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Request failed');
  }
  
  return response.json();
};

// Public fetch (no auth required)
const publicFetch = async (url, options = {}) => {
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
  
  const response = await fetch(`${API_URL}${url}`, config);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Request failed');
  }
  
  return response.json();
};

// Content API functions - Public reads, protected writes

// Releases
export const getReleases = () => publicFetch('/api/content/releases');
export const createRelease = (release) => authFetch('/api/content/releases', {
  method: 'POST',
  body: JSON.stringify(release),
});
export const updateRelease = (id, release) => authFetch(`/api/content/releases/${id}`, {
  method: 'PUT',
  body: JSON.stringify(release),
});
export const deleteRelease = (id) => authFetch(`/api/content/releases/${id}`, {
  method: 'DELETE',
});

// Events
export const getEvents = () => publicFetch('/api/content/events');
export const createEvent = (event) => authFetch('/api/content/events', {
  method: 'POST',
  body: JSON.stringify(event),
});
export const updateEvent = (id, event) => authFetch(`/api/content/events/${id}`, {
  method: 'PUT',
  body: JSON.stringify(event),
});
export const deleteEvent = (id) => authFetch(`/api/content/events/${id}`, {
  method: 'DELETE',
});

// Messages
export const getMessages = () => authFetch('/api/content/messages');
export const createMessage = async (message) => {
  // Public endpoint - no auth required for contact form
  return publicFetch('/api/content/messages', {
    method: 'POST',
    body: JSON.stringify(message),
  });
};
export const updateMessageStatus = (id, status) => authFetch(`/api/content/messages/${id}/status?status=${encodeURIComponent(status)}`, {
  method: 'PATCH',
});
export const deleteMessage = (id) => authFetch(`/api/content/messages/${id}`, {
  method: 'DELETE',
});

// About
export const getAbout = () => publicFetch('/api/content/about');
export const updateAbout = (about) => authFetch('/api/content/about', {
  method: 'PUT',
  body: JSON.stringify(about),
});
